var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlaneRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12H7.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54572 20.7469C4.49299 20.8909 4.48568 21.0477 4.52478 21.196C4.56387 21.3443 4.6475 21.477 4.76438 21.5763C4.88126 21.6756 5.02578 21.7367 5.17845 21.7514C5.33112 21.766 5.48461 21.7335 5.61822 21.6582L21.3682 12.6497C21.4854 12.5849 21.5832 12.4898 21.6512 12.3744C21.7192 12.259 21.7551 12.1274 21.7551 11.9935C21.7551 11.8595 21.7192 11.728 21.6512 11.6126C21.5832 11.4972 21.4854 11.4021 21.3682 11.3372L5.61822 2.35128C5.48501 2.27678 5.33224 2.24469 5.18031 2.25931C5.02838 2.27392 4.88453 2.33454 4.76796 2.43307C4.65139 2.5316 4.56766 2.66336 4.52795 2.81073C4.48824 2.9581 4.49444 3.11409 4.54572 3.25784L7.49979 12.0019L4.54572 20.7469Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneRight);
export default __webpack_public_path__ + "static/media/paper-plane-right.5564e2c661daa11afc49e1d41f05215c.svg";
export { ForwardRef as ReactComponent };